import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import moment from "moment";
import {confirmAlert} from "react-confirm-alert";
import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";
import CollectionOverride from "components/CollectionOverride";
import APPCONFIG from "../../constants/Config";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";



class TransactionUpload extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Transaction_Upload._name, API.RequestType.READ_ALL);
		super(props, model);

	}


	handleDocumentView = async () => {
		let uploadModel = new API.BuildClass(Types.Transaction_Upload._name, 'GET_DOCUMENT');
		uploadModel.object.binary_id = '0001';
		await uploadModel.submit(this, 'GET_DOCUMENT');
	}

	/**
	 *
	 * @param event
	 */
	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};


	/**
	 *
	 * @returns {Promise<void>}
	 */
	handleUserDelete = async () => {

		this.model.object.collection = this.props.parent;
		this.model.object.account_email = this.state.account_email;
		this.model.object.account_password = this.state.account_password;

		await this.model.submit(null, 'POST_REMOVE_UPLOAD')

		this.state.account_email = null;
		this.state.account_password = null;
		this.reloadTable();
	}

	/**
	 *
	 * @param props
	 * @returns {Promise<void>}
	 */
	handlePrintUploadedFiles = async (props) => {
			let url = `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/combined_form?location=${props.transaction_collections.location}&created=${props.created}`;
			window.open(url, "_blank");
		}

	/**
	 *
	 * @param e
	 * @returns {Promise<void>}
	 */
	handleRemoveFromUploads = async (e) => {

		this.model.object.pkey = parseInt(e.currentTarget.id.split('-')[1]);
		this.model.object.binary_id = (e.currentTarget.id.split('-')[0]);
		this.model.object.file_pkey = parseInt(e.currentTarget.id.split('-')[1]);
		!this.props.rootState.user ? confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to delete this uploaded file?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						try {
							await this.model.submit(null, 'DELETE')
							this.reloadTable();
						} catch (error) {

						}
						this.model.object.pkey = '';
						this.model.object.binary_id = '';
						this.props.reloadPage();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		}) :
			confirmAlert({
			closeOnClickOutside: false,
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert">
						<div className="react-confirm-alert-body">
							<h1>To delete this file, a Manager or the Account Owner must sign in with their credentials for approval</h1>

							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Email</span>
									</div>
									<div className={'col-8'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="account_email"
											label="Account Email"
											value={this.state.account_email}
											onChange={this.handleDataChange}
											type={"email"}
										/>
									</div>
								</div>
							</div>

							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Password</span>
									</div>
									<div className={'col-8'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="account_password"
											label="Account Password"
											value={this.state.account_password}
											onChange={this.handleDataChange}
											type={"password"}
										/>
									</div>
								</div>
							</div>

							<div style={{justifyContent: 'flex-end'}} className="react-confirm-alert-button-group">
								<div>
									<button onClick={() => {
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-default'}>Cancel
									</button>
									<button onClick={() => {
										this.handleUserDelete();
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-danger'}>
										Delete
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Document Name",
				accessor: "document_name",
			},
			{
				Header: "Document Type",
				accessor: "document_type",
			},
			{
				Header: "Created",
				accessor: "created",
			},
			{
				Header: "Description",
				accessor: "description",
			},
			{
				Header: "Print",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 120,
				/**
				 * @param  {Transaction_Upload_Object} props.original
				 */
				Cell: props => {
					if(['.m4v', '.mov', '.mp4', '.mp3'].includes(props.original.document_type)) {
						return (
							<span>
							</span>
						)
					}
					else {
						return (
							<span>
								<a href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + `/transaction_upload/document_view?image=${props.original.document_name}`} target="_blank">
							 		<Button color="blue-hoki" size={"sm"} block={true} >
										<i className={"fa fa-cloud-download"}/> Print Form
									</Button>
								</a>
							</span>
						);
					}
				}
			},
			{
				Header: "Download",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 120,
				/**
				 * @param  {Transaction_Upload_Object} props.original
				 */
				Cell: props => {
					return (
						<span>
							 {/*+ '/customers/' + object.customer_binary_id + '-' + object.customer + '/identifications/' + object.binary_id + '-' + object.pkey + '/images/back?image=' + object.image_back}*/}
							<a href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + `/transaction_upload/document?image=${props.original.document_name}`} target="_blank">
								<Button color="warning" size={"sm"} block={true} >
									<i className={"fa fa-cloud-download"}/> Download
								</Button>
							</a>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<Tooltip title={"Delete Uploaded File"}>
							<Button
								id={props.original.binary_id + '-' + props.original.pkey}
								color="danger"
								size={"sm"}
								block={true}
								onClick={this.handleRemoveFromUploads}>
								<i className={"fa fa-times-circle"}/>
							</Button>
						</Tooltip>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{/*{this.renderSearch('Uploaded Files')}*/}
								{this.renderHeaderRight("Uploaded Files", columns)}

							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(TransactionUpload)